export default __webpack_public_path__ + "static/media/DF_Characters_Mattei1.daddea5f.png";